"use client";

import { useServerInsertedHTML } from "next/navigation";
import { useRef } from "react";

/**
 * Injects the theme-boot script into the SSR HTML stream outside the React
 * client tree, so React 19 does not warn about rendering <script> tags.
 */
export function ThemeBoot() {
  // The callback runs on every chunk of the streamed page; without this the
  // two tags were written ~40 times into every page (and each copy ran).
  const inserted = useRef(false);
  useServerInsertedHTML(() => {
    if (inserted.current) return null;
    inserted.current = true;
    return (
      // External src — no inline JS payload in the React tree.
      <>
        <script key="pbd-theme-boot" src="/pbd-theme.js" />
        {/* Catches the browser's install event before the app code runs (AppInstall.tsx). */}
        <script key="pbd-install-boot" src="/pbd-install.js" async />
      </>
    );
  });
  return null;
}
